import React, { useState, useEffect, useCallback, useRef } from 'react';
import KickImage from 'Reuseables/KickImage';
import { connect } from 'react-redux';
import { useHistory, useParams } from 'react-router';

import Slider from 'react-slick';
import { IconContext } from 'react-icons';
import {
  AiOutlineRight,
  AiOutlineLeft,
  AiOutlinePlus,
  AiOutlineMinus,
} from 'react-icons/ai';
import { DropzoneRootProps, useDropzone } from 'react-dropzone';
import { GrFormDown } from 'react-icons/gr';
import _ from 'lodash';
import axios from 'axios';

// ========= action import section ========= //
import {
  doFetchProductDetails,
  searchProduct,
  sortingSearchResultAPI,
  getTicketListSetting,
} from '../../actions/productAction';
import {
  getPriceCompetitor,
  handleSuspended,
  makeSellRequest,
  makeSellRequestHandbag,
  saveImageUrl,
} from '../../actions/saleActions';
// ====== end of action import section ====== //

// ========= interface import section ========= //
import DataSellingInterface, {
  Defect,
  ISelectedUserSell,
  PriceCompetitorStateInterface,
  SellRequestStateInterface,
} from '../../interface/reducers/selling';
import AuthInterface from '../../interface/reducers/auth';
import DataProductInterface from '../../interface/reducers/product';
import { ProductSizeInterface } from '../../interface/product';
import RouteHistoryInterface from '../../interface/router';
// ====== end of interface import section ====== //

import {
  ASKING_PRICE,
  SUPPORTED_IMG_FORMATS,
  VALIDATE_AMOUNT_DELAY,
} from '../../config';
import {
  convertToRupiah,
  getCloudImageUrl,
  getFileExt,
  ImagesCompressor,
  roundUpPrice,
} from '../../utils';
import { useOutsideAlerter } from '../../helpers/dom';
import { API_BASE_URL } from '../../constants';

import DELETE_ICON from '../../images/delete1024.png';
import QUESTION_ICON from '../../images/question_commission.png';

import { isNumeric } from '../../helpers/regex';
import { getImageCategory, categoryText } from '../../utils/Helpers';
import ModalUploadImageSell from '../Modals/ModalUploadImageSell';
import { getQueryParamsUrl } from '../../helpers/url';
import ModalCommissionInfo from '../Modals/ModalCommissionInfo';
import { toast } from 'react-toastify';
import { useFecthUserSellById } from './Hooks/useFetchUserSellById';
import Styles from './SellRequest.module.scss';
import classNames from 'classnames';
import { useGetViewType } from 'Pages/Home/Hooks/useGetViewType';

type sellRequestType = {
  routes: any;
  doSearchProduct: (
    query: SearchProductPayloadType,
    status: string,
  ) => Promise<any>;
  doGetPriceCompetitor: (payload: PriceCompetitorType) => Promise<any>;
  doSaveImageUrl: (dataSaving: SaveImageType) => Promise<any>;
  doMakeSellRequest: (dataSelling: SubmitDataSellingType) => Promise<any>;
  doMakeSellRequestHandbags: (dataSelling: any) => Promise<any>;
  doHandleSuspended: (id: number, status: { status: string }) => Promise<any>;
  doGetProductDetail: (id: string) => Promise<any>;
  priceCompetitor: PriceCompetitorStateInterface;
  dataProduct: DataProductInterface;
  sellRequest: SellRequestStateInterface;
  dataSelling: DataSellingInterface;
  dataAuth: AuthInterface;
  countdown_modal?: boolean;
  selectedUserSell: ISelectedUserSell;
  doGetTicketList: () => Promise<any>;
};

type stateToProps = {
  dataSelling: DataSellingInterface;
  dataProduct: DataProductInterface;
  dataAuth: AuthInterface;
};

const SNEAKERS_BARU_PHOTO_MESSAGE = [
  'Make sure you have a good lighting to take clear picture. Take different angles of the product. Also, include any picture of the defects / issues if any.',
  'Upload 5 photos for Brand New items. Upload 7 photos for Pre Owned / Used items.',
];

const SNEAKERS_BEKAS_PHOTO_MESSAGE = [
  'Make sure you have a good lighting to take clear picture. Take different angles of the product. Also, include any picture of the defects / issues if any.',
  'Upload 5 photos for Brand New items. Upload 7 photos for Pre Owned / Used items.',
];

const STREETWEAR_PHOTO_MESSAGE = [
  'Make sure you have a good lighting to take clear picture. Take different angles of the product. Also, include any picture of the defects / issues if any.',
];

const LUXURY_PHOTO_MESSAGE = [
  'Make sure you have a good lighting to take clear picture. Take different angles of the product. Also, include any picture of the defects / issues if any.',
  'Do take pictures of all the inclusions (or accessories) that come along with the product.',
];

const TICKETS_PHOTO_MESSAGE = [
  'Make sure you have a good lighting to take clear picture. Take different angles of the product.',
];

const CATEGORY_ARRAY = [
  {
    text: 'Sneakers',
    value: 'sneakers',
    roles: 'seller',
  },
  {
    text: 'Apparel',
    value: 'apparels',
    roles: 'seller_apparel',
  },
  {
    text: 'Luxury',
    value: 'handbags',
    roles: 'seller_handbag',
  },
  {
    text: 'Electronics & Collectibles',
    value: 'lifestyles',
    roles: 'seller_lifestyle',
  },
];

type photoType = {
  isEmpty: boolean;
  file?: File;
  url?: string;
};

type ArrowType = {
  className?: string;
  style?: any;
  onClick?: () => any;
};

type SearchProductPayloadType = {
  searchKeyword: string;
  category: string;
  _scope: string;
};

type PriceCompetitorType = {
  product_variant_id: string;
  size_id: string;
  box_condition: string;
  sneakers_condition: string;
  asking_price: number;
};

type SubmitDataSellingType = {
  product_variant_id: number;
  size_id: number;
  asking_price: number;
  currency: string;
  quantity: number;
  box_condition: string;
  sneakers_condition: string;
  missing_accessories: boolean;
  yellowing: boolean;
  display_item: boolean;
  sneakers_defect: boolean;
  consignment_id: any;
  no_tags: boolean;
  no_wrap_paper: boolean;
  no_extra_laces: boolean;
  note: string;
};

type SaveImageType = {
  id: number;
  compressedImages: File;
  category: string;
};

const NextArrow = (props: ArrowType) => {
  const { className, onClick } = props;
  return (
    <div className={className} onClick={onClick}>
      <IconContext.Provider value={{ color: '#242424', size: '12.5px' }}>
        <div className={'icon'}>
          <AiOutlineRight />
        </div>
      </IconContext.Provider>
    </div>
  );
};

const PrevArrow = (props: ArrowType) => {
  const { className, onClick } = props;
  return (
    <div className={className} onClick={onClick}>
      <IconContext.Provider value={{ color: '#242424', size: '12.5px' }}>
        <div className={'icon'}>
          <AiOutlineLeft />
        </div>
      </IconContext.Provider>
    </div>
  );
};

const productConditionSneakers = [
  { value: 'BARU', label: 'BRAND NEW' },
  { value: 'BEKAS', label: 'PRE OWNED' },
];
const productConditionApparels = [
  { value: 'BARU', label: 'BRAND NEW' },
  { value: 'BEKAS', label: 'PRE OWNED' },
];
const productConditionHandbags = [
  { value: 'BARU', label: 'BRAND NEW' },
  { value: 'PRISTINE', label: 'PRISTINE' },
  { value: 'GOOD', label: 'GOOD' },
  { value: 'WELL_USED', label: 'WELL USED' },
  { value: 'LIKE_NEW', label: 'LIKE NEW' },
  { value: 'VINTAGE', label: 'VINTAGE' },
];

const productConditionList = (cat) => {
  if (cat === 'sneakers' || cat === 'lifestyles') {
    return productConditionSneakers;
  } else if (cat === 'apparels') {
    return productConditionApparels;
  } else if (cat === 'handbags') {
    return productConditionHandbags;
  }
};

const boxCondition = [
  { value: 'SEMPURNA', label: 'PERFECT' },
  { value: 'CACAT', label: 'DEFECT' },
  { value: 'NO_BOX', label: 'MISSING BOX' },
];

/**
 * Sell Request User Dashboard section for Kick Avenue 3.0 Website.
 * Author: Rifqy Zacky Ariadhy (rifqyzackya@gmail.com)
 * ===============================================
 * @param {sellRequestType} props for this component.
 * @return {JSX.Element}
 */
function SellRequest({
  doSearchProduct,
  doGetPriceCompetitor,
  priceCompetitor,
  dataProduct,
  sellRequest,
  dataSelling,
  doSaveImageUrl,
  doHandleSuspended,
  dataAuth,
  doMakeSellRequest,
  doMakeSellRequestHandbags,
  doGetProductDetail,
  seller_points,
  countdown_modal,
  selectedUserSell,
  doGetTicketList,
}: sellRequestType): JSX.Element {
  const history = useHistory();
  const urlParam = useParams<{ id: string }>();
  const paramId = urlParam?.id || '';
  const slider = useRef(null);
  const fileUploadRef = useRef(null);
  const productNameRef = useRef(null);
  const sizeSelectedRef = useRef(null);
  const sneakerConditionRef = useRef(null);
  const boxConditionRef = useRef(null);
  const sneakerPriceRef = useRef(null);
  const { isMobileView, isTabView } = useGetViewType();

  const { isFetching, data: existingData } = useFecthUserSellById({
    id: paramId,
  });
  const disableClassName = existingData ? Styles['disabled'] : '';
  const hasSuspendedSeller =
    dataAuth?.userdata?.roles?.includes('suspended_seller');
  const sellerPointsLessThanFive = parseInt(seller_points) < 5;
  const isSuspended = hasSuspendedSeller || sellerPointsLessThanFive;

  const isSellerCreditMinus =
    parseInt(dataAuth?.userdata?.balance_with_fee ?? '0') < 0;

  const [afterFirstRender, setAfterFirstRender] = useState(false);
  const wrapperRefProductResult = useRef(null);
  const [isProductSearchOpened, setProductSearchOpened] = useState(false);
  useOutsideAlerter(wrapperRefProductResult, () =>
    setProductSearchOpened(false),
  );
  const wrapperRefSize = useRef(null);
  const [isSizeOpened, setSizeOpened] = useState(false);
  useOutsideAlerter(wrapperRefSize, () => setSizeOpened(false));
  const wrapperRefProduct = useRef(null);
  const [isProductOpened, setProductOpened] = useState(false);
  useOutsideAlerter(wrapperRefProduct, () => setProductOpened(false));
  const wrapperRefBox = useRef(null);
  const [isBoxOpened, setBoxOpened] = useState(false);
  useOutsideAlerter(wrapperRefBox, () => setBoxOpened(false));

  const [isOpen, setIsOpen] = useState(false);
  const onToggle = () => {
    setIsOpen(!isOpen);
  };

  const [selectedPhoto, setSelectedPhoto] = useState<photoType[]>([]);
  const [photoIsErased, setPhotoIsErased] = useState(false);
  const [initialUpload, setInitialUpload] = useState(0);
  const [minimumPhoto, setMinimumPhoto] = useState(5);
  const [userRoles, setUserRoles] = useState(dataAuth?.userdata?.roles);

  const [listSize, setListSize] = useState<
    { id: number | string; value: number | null; label: string }[]
  >([]);
  const [changingSize, setChangingSize] = useState(false);

  const [intervalKeyDown, setIntervalKeyDown] = useState<any>(null);
  const [sneakersPrice, setSneakersPrice] = useState(0);

  // ============= main state for the form ============= //
  const [errors, setErrors] = useState<any>(null);
  const [errorPrice, setErrorPrice] = useState<any>(null);
  const [errorHighestOffer, setErrorHighestOffer] = useState<any>(null);
  const [selectedCategory, setSelectedCategory] = useState('sneakers');
  const [selectedTextCategory, setSelectedTextCategory] = useState('Sneakers');
  const [selectedSneakers, setSelectedSneakers] = useState<any>(null);
  const [hideBox, setHideBox] = useState(true);
  const [selectedSize, setSelectedSize] = useState<any>(null);
  const [selectedProductCondition, setSelectedProductCondition] = useState('');
  const [selectedBoxCondition, setSelectedBoxCondition] = useState('');
  const [note, setNote] = useState('');

  const [isUploadPhoto, setIsUploadPhoto] = useState(false);
  const [loggingImages, setIsLoggingImages] = useState(false);
  const [submitSellRequest, setSubmitSellRequest] = useState(false);
  const [hasCompressing, setHasCompressing] = useState(false);
  const [stepCompressing, setStepCompressing] = useState(0);
  const [stepUpload, setStepUpload] = useState(0);
  const [ticketList, setTicketList] = useState('');

  const prevCountryCode = usePrevious(dataAuth?.userdata?.country_code);
  const countryCode = dataAuth?.userdata?.country_code;
  // ============= main state for the form ============= //

  function usePrevious(value) {
    const ref = useRef();
    useEffect(() => {
      ref.current = value;
    });
    return ref.current;
  }

  useEffect(() => {
    setAfterFirstRender(true);

    if (isSuspended || isSellerCreditMinus) {
      history.push(`user_dashboard/sale`);
    }

    if (!dataAuth.isLogged) {
      history.push('/login');
      return;
    }

    if (
      dataAuth.userdata.roles.length > 0 &&
      !dataAuth.userdata.roles.includes('seller')
    ) {
      history.push('/seller-registration');
      return;
    }

    if (history.location.search) {
      const query = getQueryParamsUrl(history.location.search);

      const category = query.hasOwnProperty('category')
        ? ['streetwear', 'fashion', 'apparel'].includes(query.category)
          ? 'apparels'
          : query.category === 'lifestyle' ||
            query.category === 'toys' ||
            query.category === 'electronics-collectibles'
          ? 'lifestyles'
          : query.category === 'luxury'
          ? 'handbags'
          : query.category
        : 'sneakers';
      if (query.hasOwnProperty('productId')) {
        doGetTicketList().then(async (result) => {
          const data = result?.value?.data?.data[0]?.value.split(',') ?? '';
          await setTicketList(data);

          doGetProductDetail(query.productId).then(async (res) => {
            const isTicket = data.includes(res.value.data.SKU);
            getSizeBaseProductId(res.value.data.id).then(() => {
              setSearchKeyword(res.value.data.display_name);
              setSelectedSneakers(res.value.data);
              setHideBox(res.value.data.hide_box_info);
            });

            const categoryProduct = isTicket
              ? 'Tickets'
              : categoryText(category);

            setSelectedCategory(category);
            setSelectedTextCategory(categoryProduct);

            if (isTicket) {
              setSelectedProductCondition('BARU');
              setSelectedBoxCondition('SEMPURNA');
            }
          });
        });
      }
    }
  }, []);

  //VALIDATION FOR INTERNATIONAL USERS (USER LOCATION IS NOT INDONESIA)
  useEffect(() => {
    if (prevCountryCode !== countryCode) {
      if (dataAuth.userdata.country_code !== 'IDN') {
        history.push('/');
      }
    }
  }, [countryCode]);

  useEffect(() => {
    setUserRoles(dataAuth?.userdata?.roles);

    if (
      dataAuth.userdata.roles.length > 0 &&
      !dataAuth.userdata.roles.includes('seller')
    ) {
      history.push('/seller-registration');
      return;
    }
  }, [dataAuth?.userdata?.roles]);

  useEffect(() => {
    if (existingData) {
      return;
    }

    setSearchKeyword('');
    setSelectedSneakers(null);
    setHideBox(true);
    setSelectedSize(null);
    slider.current && slider.current.slickGoTo(0);
    // unset all the selected defect when change category
    setMissingAccessories(false);
    setYellowing(false);
    setDisplayItem(false);
    setDefectFromManufacture(false);
    setDiscoloration(false);
    setScratches(false);
    setTransferredColor(false);
    setSignOfWear(false);
    setMissingOriginal(false);
    setUnassembled(false);
    setRepainted(false);
    setReconditioned(false);
    setWarranty(false);
    setExtraLace(false);
    setWrappingPaper(false);
    setTag(false);
    setBox(false);
    setDustBag(false);
    setMirror(false);
    setStrap(false);
    setAuthenticationCard(false);
  }, [selectedCategory]);

  // ============== sneakers price on change handler ============== //
  useEffect(() => {
    let error: any = {};
    if (updatingSneakersPrice) {
      if (
        priceCompetitorValue.max &&
        sneakersPrice > priceCompetitorValue.max
      ) {
        error['sneakerPrice'] = 'Your price is not the lowest';
        setErrors({
          ...errors,
          ...error,
        });
      } else {
        error = errors;
        if (error?.sneakerPrice === 'Your price is not the lowest') {
          delete error.sneakerPrice;
          setErrors(error);
        }
      }
      // getCommissionAmount();
    }

    if (!selectedSneakers) return;
    if (!selectedSize) return;
    getCompetitorPrice(selectedSneakers.id, selectedSize.id);

    setUpdatingSneakersPrice(false);
  }, [sneakersPrice]);

  const onChangeCategory = (item) => {
    setSelectedCategory(item.value);
    setSelectedTextCategory(item.text);
    setSearchKeyword('');
    setSelectedSize(null);

    if (item.text === 'Tickets') {
      setSelectedProductCondition('BARU');
      setSelectedBoxCondition('SEMPURNA');
    }
  };

  const onChangePrice = () => {
    const price = `${roundUpPrice(sneakersPrice, ASKING_PRICE)}`;
    setUpdatingSneakersPrice(true);
    setSneakersPrice(parseInt(price));
    if (roundUpPrice(sneakersPrice, ASKING_PRICE) === sneakersPrice) {
      let error: any = {};
      if (
        priceCompetitorValue.max &&
        sneakersPrice > priceCompetitorValue.max
      ) {
        error['sneakerPrice'] = 'Your price is not the lowest';
        setErrors({
          ...errors,
          ...error,
        });
      } else {
        error = errors;
        if (error?.sneakerPrice === 'Your price is not the lowest') {
          delete error.sneakerPrice;
          setErrors(error);
        }
      }
    }
  };

  const roundPriceCB = useCallback(
    _.debounce((inputPrice, sCommission) => {
      const price = `${roundUpPrice(inputPrice, ASKING_PRICE)}`;
      setUpdatingSneakersPrice(false);
      setSneakersPrice(parseInt(price));
      setCommisionPrice(
        roundUpPrice(inputPrice, ASKING_PRICE) * ((100 - sCommission) / 100),
      );

      if (roundUpPrice(inputPrice, ASKING_PRICE) === inputPrice) {
        let error: any = {};
        if (priceCompetitorValue.max && inputPrice > priceCompetitorValue.max) {
          error['sneakerPrice'] = 'Your price is not the lowest';
          setErrors({
            ...errors,
            ...error,
          });
        } else {
          error = errors;
          if (error?.inputPrice === 'Your price is not the lowest') {
            delete error.inputPrice;
            setErrors(error);
          }
        }
        // getCommissionAmount();
        // setSellerPrice(inputPrice * ((100 - sellerCommission) / 100));
        setUpdatingSneakersPrice(false);
      }
    }, 1500),
    [],
  );

  const handleChangePrice = (e: any) => {
    const cursorHandle = e.target.selectionStart;
    const element = e.target;
    const currentSneakerPrice =
      Number(sneakersPrice)
        .toLocaleString('id-Id')
        .match(/^0|[^\d]+/g) &&
      Number(sneakersPrice)
        .toLocaleString('id-Id')
        .match(/^0|[^\d]+/g).length;
    const incomingSneakerPrice =
      Number(e.target.value.replace(/^0|[^\d]+/g, ''))
        .toLocaleString('id-ID')
        .match(/^0|[^\d]+/g) &&
      Number(e.target.value.replace(/^0|[^\d]+/g, ''))
        .toLocaleString('id-ID')
        .match(/^0|[^\d]+/g).length;

    window.requestAnimationFrame(() => {
      element.selectionStart = cursorHandle;
      element.selectionEnd = cursorHandle;

      if (incomingSneakerPrice - currentSneakerPrice > 0) {
        element.selectionStart += 1;
        element.selectionEnd += 1;
      }
    });

    setUpdatingSneakersPrice(true);
    setSneakersPrice(
      parseInt(
        `${e.target.value ? e.target.value.replace(/^0|[^\d]+/g, '') : 0}`,
      ),
    );
    roundPriceCB(
      `${e.target.value ? e.target.value.replace(/^0|[^\d]+/g, '') : 0}`,
      sellerCommission,
    );
  };

  const onBlur = () => {
    if (intervalKeyDown) clearTimeout(intervalKeyDown);
    setIntervalKeyDown(null);
    _validatePicture();
    onChangePrice();
    setUpdatingSneakersPrice(false);
  };

  const fixedPrice = async (type: 'increment' | 'decrement') => {
    setUpdatingSneakersPrice(true);
    if (type === 'increment') {
      setSneakersPrice(
        parseInt(
          `${(sneakersPrice + ASKING_PRICE)
            .toString()
            .replace(/^0|[^\d]+/g, '')}`,
        ),
      );
      setCommisionPrice(
        roundUpPrice(
          parseInt(
            `${(sneakersPrice + ASKING_PRICE)
              .toString()
              .replace(/^0|[^\d]+/g, '')}`,
          ),
          ASKING_PRICE,
        ) *
          ((100 - sellerCommission) / 100),
      );
    } else {
      setSneakersPrice(
        parseInt(
          `${(sneakersPrice - ASKING_PRICE)
            .toString()
            .replace(/^0|[^\d]+/g, '')}`,
        ),
      );
      setCommisionPrice(
        roundUpPrice(
          parseInt(
            `${(sneakersPrice - ASKING_PRICE)
              .toString()
              .replace(/^0|[^\d]+/g, '')}`,
          ),
          ASKING_PRICE,
        ) *
          ((100 - sellerCommission) / 100),
      );
    }
  };
  // ============== end of sneakers price on change handler ============== //

  useEffect(() => {
    if (changingSize && selectedSneakers?.id && selectedSize?.id) {
      getCompetitorPrice(selectedSneakers.id, selectedSize.id);
    }
  }, [selectedSize, selectedSneakers, changingSize]);

  // ============ price competitor handler ============ //
  const [priceCompetitorValue, setPriceCompetitorValue] = useState({
    min: 0,
    max: 0,
  });
  const [updatingSneakersPrice, setUpdatingSneakersPrice] = useState(false);
  const [sellerPrice, setSellerPrice] = useState(0);
  const [commisionPrice, setCommisionPrice] = useState(0);
  const [sellerCommission, setSellerCommission] = useState(0);

  const getCompetitorPrice = (sneakersId?: number, sizeId?: number) => {
    const descProduct = {
      product_variant_id: sneakersId
        ? sneakersId
        : selectedSneakers === null
        ? 1
        : selectedSneakers.id,
      size_id: sizeId ? sizeId : selectedSize === null ? 1 : selectedSize.id,
      box_condition:
        selectedBoxCondition === '' ? 'SEMPURNA' : selectedBoxCondition,
      sneakers_condition:
        selectedProductCondition === '' ? 'BARU' : selectedProductCondition,
      asking_price: sneakersPrice,
    };
    doGetPriceCompetitor(descProduct).then(() => setChangingSize(false));
  };

  const getCommissionAmount = _.debounce((sCommision) => {
    setCommisionPrice(sneakersPrice * ((100 - sCommision) / 100));
    setUpdatingSneakersPrice(false);
  }, 1000);

  useEffect(() => {
    const { data } = priceCompetitor;
    if (!priceCompetitor.isFetch) {
      if (!data.max_price) {
        setPriceCompetitorValue({
          min: data.lowest_price,
          max: data.highest_price,
        });
        setSellerPrice(data.seller_price);
        setSellerCommission(data.seller_commission);
        if (selectedSneakers && selectedSneakers.asking_price) {
          setSneakersPrice(parseInt(selectedSneakers.asking_price));
        } else if (sneakersPrice > 0) {
          setSneakersPrice(sneakersPrice);
        } else {
          setSneakersPrice(data.lowest_price);
        }
        setTimeout(() => getCommissionAmount(data.seller_commission), 500);
      } else {
        setPriceCompetitorValue({
          min:
            parseInt(data.min_price) < parseInt(data.max_price)
              ? parseInt(data.min_price)
              : data.lowest_price,
          max: parseInt(data.max_price),
        });
        setSellerCommission(data.seller_commission);
        setSellerPrice(
          data.seller_price === 0
            ? selectedSneakers
              ? selectedSneakers.asking_price
              : data.seller_price
            : data.seller_price,
        );
        if (selectedSneakers && selectedSneakers.asking_price) {
          setSneakersPrice(parseInt(selectedSneakers.asking_price));
        } else if (sneakersPrice > 0) {
          setSneakersPrice(sneakersPrice);
        } else {
          setSneakersPrice(data.lowest_price);
        }
        setTimeout(() => getCommissionAmount(data.seller_commission), 500);
      }
    }
  }, [priceCompetitor.isFetch, priceCompetitor.data]);
  // ============ end of price competitor handler ============ //

  // ================ sneakers search handler ================ //
  const [isSearching, setSearching] = useState(false);
  const [searchKeyword, setSearchKeyword] = useState('');
  const [page, setPage] = useState(1);
  const handleChange = (e: any) => {
    setSearching(true);
    setSearchKeyword(e.target.value);
  };
  const handleChangeNote = (e: any) => {
    setNote(e.target.value);
  };
  // keyword search handler
  useEffect(() => {
    if (isSearching) setKeywordThenSearch(searchKeyword);
  }, [searchKeyword, isSearching]);
  const setKeywordThenSearch = useCallback(
    _.debounce((t) => {
      const payload = {
        keyword: t,
        category: selectedCategory,
        sort_by: 'most_popular',
        page: 1,
        _scope: 'selling',
        // availables: true,
      };
      if (t.length > 2) {
        doSearchProduct('', { params: payload });
        setProductSearchOpened(true);
        setSearching(false);
      }
    }, 1000),
    [selectedCategory],
  );
  // ================ end of sneakers search handler ================ //

  // ================== sneakers defect selector handler ================== //
  const [missingAccessories, setMissingAccessories] = useState(false);
  const [yellowing, setYellowing] = useState(false);
  const [displayItem, setDisplayItem] = useState(false);
  const [defectFromManufacture, setDefectFromManufacture] = useState(false);

  const [discoloration, setDiscoloration] = useState(false);
  const [scratches, setScratches] = useState(false);
  const [transferredColor, setTransferredColor] = useState(false);
  const [signOfWear, setSignOfWear] = useState(false);

  const [missingOriginal, setMissingOriginal] = useState(false);

  const [unassembled, setUnassembled] = useState(false);
  const [repainted, setRepainted] = useState(false);
  const [reconditioned, setReconditioned] = useState(false);
  const [warranty, setWarranty] = useState(false);

  const [extraLace, setExtraLace] = useState(false);
  const [wrappingPaper, setWrappingPaper] = useState(false);
  const [tag, setTag] = useState(false);

  const [box, setBox] = useState(false);
  const [dustBag, setDustBag] = useState(false);
  const [mirror, setMirror] = useState(false);
  const [strap, setStrap] = useState(false);
  const [authenticationCard, setAuthenticationCard] = useState(false);

  const [updloadPhotoText, setUploadFotoText] = useState({
    top: '',
    bottom: '',
  });

  useEffect(() => {
    if (
      selectedProductCondition === 'BEKAS' &&
      selectedCategory === 'sneakers'
    ) {
      setMinimumPhoto(7);
    } else if (
      missingAccessories ||
      yellowing ||
      displayItem ||
      defectFromManufacture
    ) {
      setMinimumPhoto(6);
    } else {
      if (selectedCategory === 'handbags') {
        setMinimumPhoto(6);
      } else {
        setMinimumPhoto(5);
      }
    }
  }, [
    missingAccessories,
    yellowing,
    displayItem,
    defectFromManufacture,
    selectedProductCondition,
  ]);

  const toggleMissingAccessories = () => {
    if (missingAccessories) {
      setExtraLace(false);
      setWrappingPaper(false);
      setTag(false);
    }
    setMissingAccessories(!missingAccessories);
  };
  const toggleYellowing = () => setYellowing(!yellowing);
  const toggleDisplayItem = () => setDisplayItem(!displayItem);
  const toggleDefectFromManufacture = () =>
    setDefectFromManufacture(!defectFromManufacture);
  const toggleDiscoloration = () => setDiscoloration(!discoloration);
  const toggleScratches = () => setScratches(!scratches);
  const toggleTransferredColor = () => setTransferredColor(!transferredColor);
  const toggleSignOfWear = () => setSignOfWear(!signOfWear);
  const toggleMissingOriginal = () => setMissingOriginal(!missingOriginal);
  const toggleUnassembled = () => setUnassembled(!unassembled);
  const toggleRepainted = () => setRepainted(!repainted);
  const toggleReconditioned = () => setReconditioned(!reconditioned);
  const toggleWarranty = () => setWarranty(!warranty);

  const toggleExtraLace = () => setExtraLace(!extraLace);
  const toggleWrappingPaper = () => setWrappingPaper(!wrappingPaper);
  const toggleTag = () => setTag(!tag);
  const toggleBox = () => setBox(!box);
  const toggleDustBag = () => setDustBag(!dustBag);
  const toggleMirror = () => setMirror(!mirror);
  const toggleStrap = () => setStrap(!strap);
  const toggleAuthenticationCard = () =>
    setAuthenticationCard(!authenticationCard);
  // ================== end of sneakers defect selector handler ================== //

  // =================== image upload handler =================== //
  const { getRootProps, getInputProps } = useDropzone({
    accept: 'image/*',
    onDrop: (acceptedFiles: File[]) => {
      const currentFiles = selectedPhoto;
      let count = 0;

      for (let i = initialUpload; i < currentFiles.length; i++) {
        if (i - initialUpload < acceptedFiles.length) {
          count += 1;
          currentFiles[i] = {
            isEmpty: false,
            file: Object.assign(acceptedFiles[i - initialUpload], {
              preview: URL.createObjectURL(acceptedFiles[i - initialUpload]),
            }),
          };
        } else {
          if (currentFiles[i]?.file) {
            count += 1;
            continue;
          }

          currentFiles[i] = {
            isEmpty: true,
          };
        }
      }

      setSelectedPhoto(currentFiles);
      setInitialUpload(initialUpload + count);
    },
  });

  const onDeleteImage = (index: number) => {
    const currentFiles = selectedPhoto;
    currentFiles[index] = { isEmpty: true };
    setInitialUpload(index);
    setSelectedPhoto(currentFiles);
  };

  const _validatePicture = () => {
    const _newError: any = { ...errors };

    if (selectedPhoto.length < 5) {
      _newError['fileUploads'] = ['Please upload 5 photos.'];
    } else if (selectedPhoto.length >= 5) _newError['fileUploads'] = null;

    setErrors(_newError);
  };
  // ================ end of image upload handler ================ //

  // ================ minimum photo handler ================ //
  useEffect(() => {
    switch (selectedCategory) {
      case 'sneakers':
        const setSneakersDefaultPhoto = new Array(10)
          .fill({})
          .map(() => ({ isEmpty: true }));
        setSelectedPhoto(setSneakersDefaultPhoto);
        if (
          missingAccessories ||
          yellowing ||
          displayItem ||
          defectFromManufacture
        ) {
          setMinimumPhoto(6);
        } else {
          setMinimumPhoto(5);
        }
        break;
      case 'apparels':
        const setStreetwearDefaultPhoto = new Array(6)
          .fill({})
          .map(() => ({ isEmpty: true }));
        setSelectedPhoto(setStreetwearDefaultPhoto);
        if (
          missingAccessories ||
          yellowing ||
          displayItem ||
          defectFromManufacture
        ) {
          setMinimumPhoto(6);
        } else {
          setMinimumPhoto(5);
        }
        break;
      case 'handbags':
        const setLuxuryDefaultPhoto = new Array(12)
          .fill({})
          .map(() => ({ isEmpty: true }));
        setSelectedPhoto(setLuxuryDefaultPhoto);
        setMinimumPhoto(6);
        break;
      case 'lifestyles':
        const setLifestyleDefaultPhoto = new Array(6)
          .fill({})
          .map(() => ({ isEmpty: true }));
        setSelectedPhoto(setLifestyleDefaultPhoto);
        if (
          missingAccessories ||
          yellowing ||
          displayItem ||
          defectFromManufacture
        ) {
          setMinimumPhoto(6);
        } else {
          setMinimumPhoto(5);
        }
        break;
      default:
        break;
    }

    setPhotoIsErased(true);
  }, [selectedCategory]);

  useEffect(() => {
    if (!isFetching && existingData) {
      bindSneakerImageData(existingData);
    }

    setPhotoIsErased(false);
  }, [photoIsErased]);

  useEffect(() => {
    switch (selectedCategory) {
      case 'sneakers':
        selectedProductCondition === 'BEKAS'
          ? setUploadFotoText({
              top: SNEAKERS_BEKAS_PHOTO_MESSAGE[0],
              bottom: SNEAKERS_BEKAS_PHOTO_MESSAGE[1],
            })
          : setUploadFotoText({
              top: SNEAKERS_BARU_PHOTO_MESSAGE[0],
              bottom: SNEAKERS_BARU_PHOTO_MESSAGE[1],
            });
        break;
      case 'apparels':
      case 'lifestyles':
        setUploadFotoText({
          top: STREETWEAR_PHOTO_MESSAGE[0],
          bottom: '',
        });
        break;
      case 'handbags':
        setUploadFotoText({
          top: LUXURY_PHOTO_MESSAGE[0],
          bottom: LUXURY_PHOTO_MESSAGE[1],
        });
        break;
      case 'tickets':
        setUploadFotoText({
          top: TICKETS_PHOTO_MESSAGE[0],
          bottom: '',
        });
        break;
      default:
        break;
    }
  }, [selectedCategory, selectedProductCondition]);

  const minimumPhotoUpload = () => {
    switch (selectedCategory) {
      case 'sneakers':
      case 'lifestyles':
      case 'apparels':
        if (
          missingAccessories ||
          yellowing ||
          displayItem ||
          defectFromManufacture
        ) {
          return true;
        } else {
          return false;
        }
      case 'handbags':
      case 'tickets':
        return false;
      default:
        return false;
    }
  };
  // ================ end of minimum photo handler ================ //

  // react-slick setting props
  const settings = {
    slidesToShow: 6,
    slidesToScroll: 2,
    dots: false,
    infinite: false,
    speed: 500,
    rows: 1,
    slidesPerRow: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1023,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 2,
          dots: false,
          infinite: false,
          speed: 500,
          rows: 1,
          slidesPerRow: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2,
          dots: false,
          infinite: false,
          speed: 500,
          rows: 1,
          slidesPerRow: 1,
        },
      },
      {
        breakpoint: 424,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          dots: false,
          infinite: false,
          speed: 500,
          rows: 1,
          slidesPerRow: 1,
        },
      },
      {
        breakpoint: 319,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
          infinite: false,
          speed: 500,
          rows: 1,
          slidesPerRow: 1,
          initialSlide: 1,
        },
      },
    ],
  };

  const getSizeBaseProductId = (productId: number) => {
    const def = { id: '', value: '', label: 'SIZE (US)' };
    return axios
      .get(`${API_BASE_URL}/sizes/variants/${productId}`)
      .then((res) => {
        const _listSize = res.data.data.map(
          (_size: ProductSizeInterface, index: number) => ({
            id: _size.id,
            value: index,
            label: _size.US,
          }),
        );
        setListSize([def, ..._listSize]);
        setSelectedSize(_listSize[0]);
        getCompetitorPrice(productId, _listSize[0].id);
        return res;
      })
      .catch((err) => {
        setListSize([def]);
      });
  };

  /**
   * Timer to check time uploading to S3
   */
  const [intervalId, setIntervalId] = useState<any>(null);
  const [timeUpload, setTimeUpload] = useState(0);
  const [slowNetworkRedirect, setSlowNetworkRedirect] = useState(false);
  const [slowNetwork, setSlowNetwork] = useState(false);
  const timer = () => {
    if (timeUpload === 300) {
      setSlowNetworkRedirect(true);
      clearInterval(intervalId);
    } else if (timeUpload === 200) {
      setSlowNetwork(true);
    }
    setTimeUpload(timeUpload + 1);
  };

  // SAVING URL IMAGE TO KA-API
  const handleSaveImageUrl = async () => {
    const { sellRequest } = dataSelling;
    const compressed = selectedPhoto.filter((t) => !t.isEmpty);
    for (let i = 0; i < compressed.length; ) {
      const dataSaving = {
        id: sellRequest.details.id,
        compressedImages: compressed[i].file,
        category: selectedCategory,
      };
      let isError = false;
      await doSaveImageUrl(dataSaving)
        .then(async (res) => {
          i++;
          if (i === compressed.length - 1) {
            (await res.value.data.status) === 'draft' &&
              doHandleSuspended(res.value.data.id, {
                status: 'awaiting_review',
              });
            setIsUploadPhoto(false);
            setSubmitSellRequest(false);
            history.replace('/user_dashboard/sale');
          }
        })
        .catch((err) => {
          isError = true;
        });
      if (isError) break;
    }
  };

  const onSubmitOnlyImages = async () => {
    if (!existingData || !isFullFiled()) {
      return;
    }

    const validation = await validateForm(true);

    if (Object.keys(validation).length > 0) {
      return;
    }

    const sellRequest = existingData;
    let compressed;

    await setSubmitSellRequest(true);

    setHasCompressing(true);
    compressed = await imageCompressor();
    setHasCompressing(false);
    setSelectedPhoto(compressed);
    setIntervalId(setInterval(timer, 1000));
    setIsUploadPhoto(true);

    let sellId = 0;
    let successUploadCount = 0;
    let userSellImagesCount = 0;
    let isStillDraft = false;

    for (let i = 0; i < compressed.length; ) {
      const dataSaving = {
        id: sellRequest.id,
        compressedImages: compressed[i].file,
        category: selectedCategory,
      };

      await doSaveImageUrl(dataSaving)
        .then(async (res) => {
          i++;
          successUploadCount++;

          if (i === compressed.length) {
            const responseData = res.value.data;
            sellId = responseData.id;
            isStillDraft = responseData.status === 'draft';
            userSellImagesCount = responseData.user_sell_images.length;
          }
        })
        .catch((err) => {
          console.error('failed to upload', err);
          setIsUploadPhoto(false);
          setSubmitSellRequest(false);
          toast.error(
            'Upload Failed. Please try again later or contact our CS',
          );
        });
    }

    if (isStillDraft && userSellImagesCount >= minimumPhoto) {
      await doHandleSuspended(sellId, {
        status: 'awaiting_review',
      });
    }

    setIsUploadPhoto(false);
    setSubmitSellRequest(false);
    toast.success('Upload Success!', {
      position: 'top-right',
      delay: 2000,
    });

    history.replace('/user_dashboard/sale');
  };

  // ================ component did update handler in previous code ================ //
  useEffect(() => {
    if (typeof intervalId === 'function') {
      intervalId();
    }
  }, [intervalId]);
  useEffect(() => {
    const fetchUpdateHandler = async () => {
      if (sellRequest.status_code === 200 && submitSellRequest) {
        if (hasCompressing) {
          const compressed = await imageCompressor();

          setSelectedPhoto(compressed);
          setHasCompressing(false);
          setIntervalId(setInterval(timer, 1000));
        }
        // setSubmitSellRequest(false);
        setIsUploadPhoto(true);
        handleSaveImageUrl();
      } else {
        if (
          sellRequest?.error?.status_code &&
          sellRequest?.error?.status_code === 400
        ) {
          const { message } = sellRequest.error;
          let _errorHighestOfferRp = null;
          if (/\(IDR.+\).$/.test(message)) {
            // check if has highest offer value
            _errorHighestOfferRp = message.substring(
              message.indexOf('(') + 1,
              message.indexOf(')'),
            );
          }
          setErrorHighestOffer(_errorHighestOfferRp);
          setErrorPrice(true);
          setSubmitSellRequest(false);
          setHasCompressing(false);
          validateForm();
        }
      }
    };
    fetchUpdateHandler();

    return () => {};
  }, [sellRequest.isFetch]);
  useEffect(() => {
    if (afterFirstRender) {
      const { uploadPhotos } = dataSelling;
      const filterUploadsProduct = selectedPhoto.filter(
        (value) => !value.isEmpty,
      );
      if (uploadPhotos.detailsUrl.length === filterUploadsProduct.length) {
        setIsUploadPhoto(false);
        setIsLoggingImages(true);
        handleSaveImageUrl();
      } else if (uploadPhotos.detailsUrl.length > stepUpload) {
        setStepUpload(stepUpload + 1);
      } else if (slowNetworkRedirect) {
        setIsUploadPhoto(false);
        setSlowNetworkRedirect(false);
        setIsLoggingImages(true);
        handleSaveImageUrl();
      }
    }
  }, [dataSelling.uploadPhotos]);
  useEffect(() => {
    const { loggingImage } = dataSelling;
    if (loggingImage.status_code === 200 && loggingImages) {
      setIsLoggingImages(false);
      history.replace('/user_dashboard/sale');
    }
  }, [dataSelling.loggingImage]);
  // ================ end of component did update handler in previous code ================ //

  const imageCompressor = async () => {
    const filterUploadsProduct = selectedPhoto.filter(
      (value) => !value.isEmpty && value.file,
    );
    const _hasCompressing: photoType[] = [];
    for (let i = 0; i < filterUploadsProduct.length; ) {
      setStepCompressing(i);
      let compressor;
      try {
        const compressedFile = await ImagesCompressor(
          filterUploadsProduct[i].file,
        );
        compressor = { ...filterUploadsProduct[i], file: compressedFile };
      } catch (e) {
        compressor = filterUploadsProduct[i];
      }
      _hasCompressing.push(compressor);
      i++;
    }
    return _hasCompressing;
  };

  // ============= error validation handler ============= //
  const hasError = (name: string) => {
    if (errors !== null) {
      if (!errors[name]) {
        return false;
      }
      return Object.keys(errors).filter((err) => err === name).length > 0;
    }
    return false;
  };

  const validateFilesExtension = (files: File[]) => {
    let isValid = true;
    for (let i = 0; i < files.length; i++) {
      const ext = getFileExt(files[i].name);
      const isSupported =
        SUPPORTED_IMG_FORMATS.find(
          (i) => i === (ext ? ext.toLowerCase() : ext),
        ) !== undefined;
      if (!isSupported) {
        isValid = !isValid;
        break;
      }
    }
    return isValid;
  };

  const getUnsupportedImageError = () =>
    `Uploaded file is not a valid image. Only ${SUPPORTED_IMG_FORMATS.join(
      ', ',
    )} files are allowed.`;

  const validateForm = (isOnlyImage: boolean = false) => {
    const error: any = {};
    const checkLength = selectedPhoto.filter((item) => {
      if (!item.isEmpty) return item;
    });
    const images: File[] = selectedPhoto
      .filter((img) => !img.isEmpty && img.file)
      .map((item) => item.file);

    if (
      (!(checkLength.length >= minimumPhoto && checkLength.length <= 10) &&
        selectedProductCondition !== 'BEKAS') ||
      (checkLength.length < minimumPhoto &&
        selectedProductCondition === 'BEKAS')
    ) {
      error['fileUploads'] = [
        `Sorry, you have to upload ${minimumPhoto} photos`,
      ];
    } else if (!validateFilesExtension(images)) {
      error['fileUploads'] = [getUnsupportedImageError()];
    }

    if (isOnlyImage) {
      setErrors(error);
      return error;
    }

    if (searchKeyword === '') {
      error['name'] = ['Please find product that you want to sell.'];
    }
    if (selectedSize === '') {
      error['sizeSelected'] = ['Please choose size.'];
    }
    if (selectedSize.value !== undefined) {
      if (selectedSize.value === '') {
        error['sizeSelected'] = ['Please choose size.'];
      }
    }
    if (selectedSneakers === null) {
      error['sneakerSelected'] = ['Please find product that you want to sell.'];
    }
    if (selectedProductCondition === '') {
      error['kondisiSneaker'] = ['Please choose product condition.'];
    }
    if (selectedBoxCondition === '') {
      error['kondisiBox'] = ['Please choose box condition.'];
    }
    if (sneakersPrice === 0) {
      error['sneakerPrice'] = ['Please input product price.'];
    }
    if (sneakersPrice < 50000) {
      error['sneakerPrice'] = [
        'Sorry, your sneakers price exceeds the minimum price.',
      ];
    }
    if (!isNumeric(sneakersPrice)) {
      error['sneakerPrice'] = ['Product price must be numeric.'];
    }
    if (errorPrice) {
      let errPriceStr = 'Your price is lower than highest offer.';
      const errPriceArr = [];
      if (errorHighestOffer !== null) {
        errPriceStr += ` The current highest offer is ${errorHighestOffer}.`;
        errPriceArr.push(errPriceStr);
        errPriceArr.push(
          'We recommend to place your price above the current highest offer.',
        );
      }
      error['sneakerPrice'] = [...errPriceArr];
    }

    setErrors(error);
    return error;
  };

  useEffect(() => {
    if (afterFirstRender) {
      const error: any = {};
      const checkLength = selectedPhoto.filter((item) => !item.isEmpty);
      const images: File[] = selectedPhoto
        .filter((img) => !img.isEmpty && img.file)
        .map((item) => item.file);
      if (
        (!(checkLength.length >= minimumPhoto && checkLength.length <= 10) &&
          selectedProductCondition !== 'BEKAS') ||
        (checkLength.length < minimumPhoto &&
          selectedProductCondition === 'BEKAS')
      ) {
        error['fileUploads'] = [
          `Sorry, you have to upload ${minimumPhoto} photos`,
        ];
      } else if (!validateFilesExtension(images)) {
        error['fileUploads'] = [getUnsupportedImageError()];
      }
      setErrors(error);
    }
  }, [initialUpload, minimumPhoto]);

  const scrollToErrorHandler = () => {
    if (
      hasError('sneakerPrice') ||
      sneakersPrice < 50000 ||
      sneakersPrice === 0
    ) {
      sneakerPriceRef?.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
      return;
    }

    if (hasError('name')) {
      productNameRef?.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
      return;
    }

    if (hasError('sizeSelected')) {
      sizeSelectedRef?.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
      return;
    }
    if (hasError('kondisiSneaker')) {
      sneakerConditionRef?.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
      return;
    }
    if (hasError('kondisiBox')) {
      boxConditionRef?.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
      return;
    }
    if (hasError('fileUploads')) {
      fileUploadRef?.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
      return;
    }
  };

  const isFullFiled = () => {
    const checkLength = selectedPhoto.filter((t) => !t.isEmpty);
    const minPhotos =
      missingAccessories || yellowing || displayItem || defectFromManufacture
        ? 6
        : 5;

    if (existingData) {
      if (checkLength.length >= minPhotos && checkLength.length <= 10) {
        return true;
      }
    }

    if (isSuspended) return false;
    if (isSellerCreditMinus) return false;

    if (hasError('fileUploads')) return false;

    if (updatingSneakersPrice) {
      return false;
    }

    if (sneakersPrice < 50000) {
      return false;
    }

    if (
      searchKeyword &&
      selectedSize &&
      selectedSneakers &&
      selectedProductCondition &&
      selectedBoxCondition &&
      sneakersPrice >= 50000 &&
      checkLength.length >= minPhotos &&
      checkLength.length <= 10
    ) {
      return true;
    }
    if (
      selectedTextCategory === 'Tickets' &&
      searchKeyword &&
      selectedSize &&
      selectedSneakers &&
      sneakersPrice >= 50000 &&
      checkLength.length >= minPhotos &&
      checkLength.length <= 10
    ) {
      return true;
    }
    return false;
  };
  // ============= end of error validation handler ============= //

  /**
   * submitSellRequest will execute after image seller
   * uploaded to S3
   */
  const doSubmitSellRequest = () => {
    if (selectedCategory === 'handbags') {
      const dataSelling = {
        product_variant_id: selectedSneakers.id,
        size_id: selectedSize.hasOwnProperty('id') ? selectedSize.id : null,
        asking_price: sneakersPrice,
        currency: 'IDR',
        quantity: 1,
        note,
        box_condition: selectedBoxCondition,
        sneakers_condition: selectedProductCondition,
        missing_accessories: missingAccessories,
        discoloration,
        scratches,
        transferred_color: transferredColor,
        sign_of_wear: signOfWear,
        inclusions: {
          box,
          dust_bag: dustBag,
          tag,
          mirror,
          straps: strap,
          authentication_card: authenticationCard,
        },
      };
      return doMakeSellRequestHandbags(dataSelling).catch((err) => {
        setSubmitSellRequest(false);
        setIsUploadPhoto(false);
        toast.error(
          err?.response?.data?.error?.message
            ? err?.response?.data?.error?.message
            : 'Sorry, your selected product is not available to be sell',
          {
            position: 'top-right',
            autoClose: 5000,
            closeOnClick: true,
            pauseOnHover: true,
          },
        );
        throw err;
      });
    } else if (
      selectedCategory === 'lifestyles' &&
      selectedTextCategory === 'Tickets'
    ) {
      const dataSelling = {
        product_variant_id: selectedSneakers.id,
        size_id: selectedSize.id,
        asking_price: sneakersPrice,
        currency: 'IDR',
        quantity: 1,
        box_condition: selectedBoxCondition,
        sneakers_condition: selectedProductCondition,
        missing_accessories: missingAccessories,
        discoloration,
        scratches,
        transferred_color: transferredColor,
        sign_of_wear: signOfWear,
        inclusions: {
          box,
          dust_bag: dustBag,
          tag,
          mirror,
          straps: strap,
          authentication_card: authenticationCard,
        },
        note,
      };
      return doMakeSellRequestHandbags(dataSelling).catch((err) => {
        setSubmitSellRequest(false);
        setIsUploadPhoto(false);
        toast.error(
          err?.response?.data?.error?.message
            ? err?.response?.data?.error?.message
            : 'Sorry, your selected product is not available to be sell',
          {
            position: 'top-right',
            autoClose: 5000,
            closeOnClick: true,
            pauseOnHover: true,
          },
        );
        throw err;
      });
    } else {
      let dataSelling = {
        product_variant_id: selectedSneakers.id,
        size_id: selectedSize.id,
        asking_price: sneakersPrice,
        currency: 'IDR',
        quantity: 1,
        box_condition: selectedBoxCondition,
        sneakers_condition: selectedProductCondition,
        missing_accessories: missingAccessories,
        yellowing,
        display_item: displayItem,
        sneakers_defect: defectFromManufacture,
        consignment_id: null,
        no_tags: tag,
        no_wrap_paper: wrappingPaper,
        no_extra_laces: extraLace,
        note,
      };
      switch (selectedCategory) {
        case 'sneakers':
          dataSelling = {
            product_variant_id: selectedSneakers.id,
            size_id: selectedSize.id,
            asking_price: sneakersPrice,
            currency: 'IDR',
            quantity: 1,
            box_condition: selectedBoxCondition,
            sneakers_condition: selectedProductCondition,
            missing_accessories: missingAccessories,
            yellowing,
            display_item: displayItem,
            sneakers_defect: defectFromManufacture,
            consignment_id: null,
            no_tags: tag,
            no_wrap_paper: wrappingPaper,
            no_extra_laces: extraLace,
            note,
          };
          break;
        case 'apparels':
          dataSelling = {
            product_variant_id: selectedSneakers.id,
            size_id: selectedSize.id,
            asking_price: sneakersPrice,
            currency: 'IDR',
            quantity: 1,
            box_condition: selectedBoxCondition,
            sneakers_condition: selectedProductCondition,
            sneakers_defect: defectFromManufacture,
            missing_original: missingOriginal,
            no_tags: tag,
            consignment_id: null,
            note,
          };
          break;
        case 'lifestyles':
          dataSelling = {
            product_variant_id: selectedSneakers.id,
            size_id: selectedSize.id,
            asking_price: sneakersPrice,
            currency: 'IDR',
            quantity: 1,
            box_condition: selectedBoxCondition,
            sneakers_condition: selectedProductCondition,
            no_tags: tag,
            missing_accessories: missingAccessories,
            manufacture_defect: defectFromManufacture,
            unassambled: unassembled,
            scratches,
            repainted,
            reconditioned,
            no_warranty: warranty,
            display_item: displayItem,
            discoloration,
            consignment_id: null,
            note,
          };
          break;
        default:
          break;
      }
      return doMakeSellRequest(dataSelling).catch((err) => {
        setSubmitSellRequest(false);
        setIsUploadPhoto(false);
        toast.error(
          err?.response?.data?.error?.message
            ? err?.response?.data?.error?.message
            : 'Sorry, your selected product is not available to be sell',
          {
            position: 'top-right',
            autoClose: 5000,
            closeOnClick: true,
            pauseOnHover: true,
          },
        );
        throw err;
      });
    }
  };

  const onSubmit = async () => {
    if (isFullFiled()) {
      setErrorPrice(false);
      setErrorHighestOffer(null);
      const validation = await validateForm();
      if (Object.keys(validation).length === 0) {
        doGetProductDetail(selectedSneakers.id).then(async (res) => {
          if (res.value.data.receive_sell) {
            await setSubmitSellRequest(true);
            await setHasCompressing(true);
            doSubmitSellRequest();
          } else {
            toast.error(
              'Sorry, your selected product is not available to be sell',
              {
                position: 'top-right',
                autoClose: 5000,
                closeOnClick: true,
                pauseOnHover: true,
              },
            );
          }
        });
      }
    } else {
      scrollToErrorHandler();
    }
  };

  const bindSneakerBasicData = (existingData: ISelectedUserSell) => {
    setSelectedSneakers(existingData.product_variant);
    setSelectedCategory(existingData.product_variant.product.category.name);
    setSearchKeyword(existingData.product_variant.display_name);
    setNote(existingData.note || '-');
    setSneakersPrice(parseInt(existingData.asking_price));
    setSelectedSize({
      id: existingData.size_id,
      value: existingData.size.US,
      label: existingData.size.US,
    });
  };

  const bindDefectData = (existingData: ISelectedUserSell) => {
    const category = existingData.product_variant.product.category.name;
    const isSneaker = category === 'sneakers';
    setDisplayItem(existingData.display_item);
    setMissingAccessories(existingData.missing_accessories);
    setYellowing(existingData.yellowing);
    setDefectFromManufacture(existingData.sneakers_defect);
    setHideBox(existingData.product_variant.hide_box_info);

    const handleSetter = (defect: Defect) => {
      const value = defect.value;

      if (defect.name === 'AUTHENTICATION_CARD') {
        setAuthenticationCard(value);
        return;
      }

      if (defect.name === 'BOX') {
        setBox(value);
        return;
      }

      if (defect.name === 'DISCOLORATION') {
        setDiscoloration(value);
        return;
      }

      if (defect.name === 'DUST_BAG') {
        setDustBag(value);
        return;
      }

      if (defect.name === 'MANUFACTURE_DEFECT') {
        if (!isSneaker) {
          return;
        }

        setDefectFromManufacture(value);
        return;
      }

      if (defect.name === 'MIRROR') {
        setMirror(value);
        return;
      }

      if (defect.name === 'MISSING_ORIGINAL') {
        setMissingOriginal(value);
        return;
      }

      if (defect.name === 'NO_EXTRA_LACES') {
        setExtraLace(value);
        return;
      }

      if (defect.name === 'NO_TAGS') {
        if (tag) {
          return;
        }

        setTag(value);
        return;
      }

      if (defect.name === 'NO_WARRANTY') {
        setWarranty(value);
        return;
      }

      if (defect.name === 'NO_WRAP_PAPER') {
        setWrappingPaper(value);
        return;
      }

      if (defect.name === 'RECONDITIONED') {
        setReconditioned(value);
        return;
      }

      if (defect.name === 'REPAINTED') {
        setRepainted(value);
        return;
      }

      if (defect.name === 'SCRATCHES') {
        setScratches(value);
        return;
      }

      if (defect.name === 'SIGN_OF_WEAR') {
        setSignOfWear(value);
        return;
      }

      if (defect.name === 'STRAPS') {
        setStrap(value);
        return;
      }

      if (defect.name === 'TAG') {
        if (tag) {
          return;
        }

        setTag(value);
        return;
      }

      if (defect.name === 'TRANSFERRED_COLOR') {
        setTransferredColor(value);
        return;
      }

      if (defect.name === 'UNASSAMBLED') {
        setUnassembled(value);
        return;
      }
    };

    existingData.defects.forEach((defect) => {
      handleSetter(defect);
    });
  };

  const bindSneakerConditionData = (existingData: ISelectedUserSell) => {
    setSelectedProductCondition(existingData.sneakers_condition);
    setSelectedBoxCondition(existingData.box_condition);
  };

  const bindSneakerImageData = (existingData: ISelectedUserSell) => {
    const newSelectedPhotos = [...selectedPhoto];
    existingData.user_sell_images.forEach((image, index) => {
      const photo = newSelectedPhotos[index];
      photo.isEmpty = false;
      photo.url = image.URL;
    });

    setSelectedPhoto(newSelectedPhotos);
    setInitialUpload(existingData.user_sell_images.length);
  };

  useEffect(() => {
    if (!isFetching && existingData) {
      if (existingData.user_sell_images.length >= minimumPhoto) {
        history.replace('/user_dashboard/sale');
      }
      const { product } = existingData.product_variant;
      bindSneakerBasicData(existingData);
      bindSneakerConditionData(existingData);
      bindDefectData(existingData);
      bindSneakerImageData(existingData);

      getCompetitorPrice(product.id, existingData.size_id);
      getCommissionAmount(priceCompetitor.data.seller_commission);
    }
  }, [isFetching, existingData]);

  useEffect(() => {
    if (submitSellRequest || isUploadPhoto) {
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.height = '0px';

      return;
    }

    document.body.style.overflow = 'scroll';
    document.body.style.position = 'initial';
    document.body.style.height = '100vh';
  }, [submitSellRequest, isUploadPhoto]);

  const categoryArrayWithTickets = [
    ...CATEGORY_ARRAY,
    {
      text: 'Tickets',
      value: 'lifestyles',
      roles: 'seller_ticket',
    },
  ];
  const categoryArray = userRoles.includes('seller_ticket')
    ? categoryArrayWithTickets
    : CATEGORY_ARRAY;

  const searchResult = dataProduct && dataProduct.searchResult;

  const productWithoutTicket = searchResult.filter(
    (item) => !ticketList.includes(item.SKU),
  );

  const productList =
    userRoles.includes('seller_ticket') && selectedTextCategory == 'Tickets'
      ? searchResult
      : productWithoutTicket;
  return (
    <div
      className={
        countdown_modal
          ? 'page-container is-countdown-active'
          : 'page-container'
      }
      id={'sell-request-container'}
    >
      <div className={'container'}>
        <div className={'title-text'}>Sell Now</div>
        <div className={'category-section'}>
          <p>Choose Category</p>
          <div className={'choose-category-container'}>
            {categoryArray.map((t) => {
              const isSelected = t.text === selectedTextCategory;
              const isDisable = !userRoles.includes(t.roles) || existingData;
              const isTicket = t.text === 'Tickets';
              const imageCategory = isTicket
                ? getImageCategory(t.text)
                : getImageCategory(t.value);
              const onClick = () => (isDisable ? null : onChangeCategory(t));
              return (
                <div
                  className={classNames(
                    `category-container ${isSelected ? 'selected' : ''}`,
                    isSelected ? '' : disableClassName,
                  )}
                  key={t.value}
                  onClick={onClick}
                >
                  <KickImage src={imageCategory} className={'image'} />
                  <p>{t.text}</p>
                </div>
              );
            })}
          </div>
        </div>
        <div className={'photo-section'} ref={fileUploadRef}>
          <p>Upload Photos ( Minimum {minimumPhoto} Photos )</p>
          <p>{updloadPhotoText.top}</p>
          <p>{updloadPhotoText.bottom}</p>
          <Slider {...settings} ref={slider}>
            {selectedPhoto.map((t, i) => {
              if (!minimumPhotoUpload() && i === selectedPhoto.length - 1) {
                return null;
              }
              // function for calling the delete image method
              const deleteImage = () => onDeleteImage(i);
              // for rendering if the image slot has no photo
              const renderEmptyPhoto = (
                <IconContext.Provider
                  value={{ color: '#bebebe', size: '37px' }}
                >
                  <div>
                    <AiOutlinePlus />
                  </div>
                </IconContext.Provider>
              );
              const imageSource = t?.file?.preview || t?.url;
              // for rendering if the image slot has photo
              const renderPhotoDesktop = (
                <>
                  <KickImage src={imageSource} className={'image-photo'} />
                  {!!t.file && (
                    <div className={'image-photo-hover'}>
                      <KickImage src={DELETE_ICON} onClick={deleteImage} />
                    </div>
                  )}
                </>
              );

              const renderPhotoMobile = (
                <>
                  <KickImage src={imageSource} className={'image-photo'} />
                  {!!t.file && (
                    <div className={Styles['image-photo-hover']}>
                      <KickImage src={DELETE_ICON} onClick={deleteImage} />
                    </div>
                  )}
                </>
              );
              const renderPhoto =
                isMobileView || isTabView
                  ? renderPhotoMobile
                  : renderPhotoDesktop;
              // condition whether the image slot has photo or not
              const renderPhotoComponent = t.isEmpty
                ? renderEmptyPhoto
                : renderPhoto;
              // variable to store the component props
              let componentProps: DropzoneRootProps = {
                className: 'photo-container',
              };
              // if the image slot are empty, assign the dropzone props
              if (t.isEmpty) {
                componentProps = getRootProps({ className: 'photo-container' });
              }
              // return the view of the image slot
              // console.log(getInputProps(), '==============================');
              const key = selectedPhoto.length + i;
              return (
                <div {...componentProps}>
                  <input {...getInputProps()} key={key} />
                  {renderPhotoComponent}
                </div>
              );
            })}
          </Slider>
          {hasError('fileUploads') && (
            <p className={'error-text'}>{errors?.fileUploads?.[0]}</p>
          )}
        </div>
        <div className={'input-section'} ref={productNameRef}>
          <p>Product Name</p>
          <input
            type={'text'}
            placeholder={'Input Name or SKU of the Product'}
            onChange={handleChange}
            value={searchKeyword}
            disabled={!!existingData}
            className={disableClassName}
          />
          {isProductSearchOpened && (
            <div
              ref={wrapperRefProductResult}
              className={'search-product-result-container'}
            >
              {searchResult.length ? (
                productList &&
                productList.map((t) => {
                  const onClick = () => {
                    getSizeBaseProductId(t.id).then(() => {
                      setSearchKeyword(t.display_name);
                      setSelectedSneakers(t);
                      setHideBox(t.hide_box_info);
                      setProductSearchOpened(false);
                    });
                  };
                  return (
                    <div
                      className={'search-product-item'}
                      onClick={onClick}
                      key={t.id}
                    >
                      <KickImage
                        src={
                          t.product_variant_images.length
                            ? getCloudImageUrl(
                                t.product_variant_images[0].URL,
                                100,
                              )
                            : 'http://americanconstruction.net/wp-content/uploads/2015/10/upload-empty.png'
                        }
                      />
                      <p>{t.display_name}</p>
                    </div>
                  );
                })
              ) : (
                <div />
              )}
              <div
                className={'search-product-item'}
                onClick={() => history.replace('/sku-request')}
              >
                <p className={'no-brand'}>Can't find brand or SKU?</p>
              </div>
            </div>
          )}
          {hasError('name') && <p className={'error-text'}>{errors.name[0]}</p>}
        </div>
        <div className={'input-section'} ref={sizeSelectedRef}>
          <p>Size (US)</p>
          <div
            className={classNames('text-box', disableClassName)}
            onClick={() => {
              if (existingData) {
                return;
              }

              if (listSize.length) {
                setSizeOpened(true);
              }
            }}
          >
            <p>
              {selectedSize && selectedSize.label
                ? selectedSize.label
                : 'Select Size'}
            </p>
            <IconContext.Provider value={{ color: '#242424', size: '15px' }}>
              <div className={'icon-dropdown'}>
                <GrFormDown />
              </div>
            </IconContext.Provider>
          </div>
          {isSizeOpened && (
            <div
              ref={wrapperRefSize}
              className={'search-product-result-container'}
            >
              {listSize.map((t) => {
                const onClick = () => {
                  setSelectedSize(t);
                  setChangingSize(true);
                  setSizeOpened(false);
                };
                return (
                  <div
                    className={`search-size-item${
                      t === selectedSize ? ' selected' : ''
                    }`}
                    onClick={onClick}
                    key={t.id}
                  >
                    <p>{t.label}</p>
                  </div>
                );
              })}
            </div>
          )}
          {hasError('sizeSelected') && (
            <p className={'error-text'}>{errors.sizeSelected[0]}</p>
          )}
        </div>
        {selectedTextCategory !== 'Tickets' && (
          <div className={'input-section'} ref={sneakerConditionRef}>
            <p>Product Condition</p>
            <div
              className={classNames('text-box', disableClassName)}
              onClick={() => {
                if (existingData) {
                  return;
                }

                setProductOpened(true);
              }}
            >
              <p
                className={selectedProductCondition === '' ? 'placeholder' : ''}
              >
                {selectedProductCondition === ''
                  ? 'Select Product Condition'
                  : productConditionList(selectedCategory).find(
                      (t) => t.value === selectedProductCondition,
                    )?.label}
              </p>
              <IconContext.Provider value={{ color: '#242424', size: '15px' }}>
                <div className={'icon-dropdown'}>
                  <GrFormDown />
                </div>
              </IconContext.Provider>
            </div>
            {isProductOpened && (
              <div
                ref={wrapperRefProduct}
                className={'search-product-result-container'}
              >
                {productConditionList(selectedCategory).map((t) => {
                  const onClick = () => {
                    setSelectedProductCondition(t.value);
                    setProductOpened(false);
                  };
                  return (
                    <div
                      className={`search-size-item${
                        t.value === selectedProductCondition ? ' selected' : ''
                      }`}
                      onClick={onClick}
                      key={t.value}
                    >
                      <p>{t.label}</p>
                    </div>
                  );
                })}
              </div>
            )}
            {hasError('kondisiSneaker') && (
              <p className={'error-text'}>{errors.kondisiSneaker[0]}</p>
            )}
          </div>
        )}
        {!hideBox && selectedTextCategory !== 'Tickets' && (
          <div className={'input-section'} ref={boxConditionRef}>
            <p>Packaging / Box Condition</p>
            <div
              className={classNames('text-box', disableClassName)}
              onClick={() => {
                if (existingData) {
                  return;
                }
                setBoxOpened(true);
              }}
            >
              <p className={selectedBoxCondition === '' ? 'placeholder' : ''}>
                {selectedBoxCondition === ''
                  ? 'Select Packaging / Box Condition'
                  : boxCondition.find((t) => t.value === selectedBoxCondition)
                      ?.label}
              </p>
              <IconContext.Provider value={{ color: '#242424', size: '15px' }}>
                <div className={'icon-dropdown'}>
                  <GrFormDown />
                </div>
              </IconContext.Provider>
            </div>
            {isBoxOpened && (
              <div
                ref={wrapperRefBox}
                className={'search-product-result-container'}
              >
                {boxCondition.map((t) => {
                  const onClick = () => {
                    setSelectedBoxCondition(t.value);
                    setBoxOpened(false);
                  };
                  return (
                    <div
                      className={`search-size-item${
                        t.value === selectedBoxCondition ? ' selected' : ''
                      }`}
                      onClick={onClick}
                      key={t.value}
                    >
                      <p>{t.label}</p>
                    </div>
                  );
                })}
              </div>
            )}
            {hasError('kondisiBox') && (
              <p className={'error-text'}>{errors.kondisiBox[0]}</p>
            )}
          </div>
        )}
        {selectedTextCategory !== 'Tickets' && (
          <div className={'select-section'}>
            <p>Others (Select as many as necessary, otherwise, ignore)</p>
            <div className={'choose-container'}>
              {selectedCategory === 'handbags' ? (
                <>
                  <div
                    className={classNames(
                      `choose-item${missingAccessories ? ' selected' : ''}`,
                      missingAccessories ? '' : disableClassName,
                    )}
                    onClick={existingData ? () => {} : toggleMissingAccessories}
                  >
                    <p>Missing Accessories</p>
                  </div>
                  <div
                    className={classNames(
                      `choose-item${discoloration ? ' selected' : ''}`,
                      discoloration ? '' : disableClassName,
                    )}
                    onClick={existingData ? () => {} : toggleDiscoloration}
                  >
                    <p>Discoloration</p>
                  </div>
                  <div
                    className={classNames(
                      `choose-item${scratches ? ' selected' : ''}`,
                      scratches ? '' : disableClassName,
                    )}
                    onClick={existingData ? () => {} : toggleScratches}
                  >
                    <p>Scratches</p>
                  </div>
                  <div
                    className={classNames(
                      `choose-item${transferredColor ? ' selected' : ''}`,
                      transferredColor ? '' : disableClassName,
                    )}
                    onClick={existingData ? () => {} : toggleTransferredColor}
                  >
                    <p>Transferred Color</p>
                  </div>
                  <div
                    className={classNames(
                      `choose-item${signOfWear ? ' selected' : ''}`,
                      signOfWear ? '' : disableClassName,
                    )}
                    onClick={existingData ? () => {} : toggleSignOfWear}
                  >
                    <p>Sign Of Wear</p>
                  </div>
                </>
              ) : selectedCategory === 'apparels' ? (
                <>
                  <div
                    className={classNames(
                      `choose-item${tag ? ' selected' : ''}`,
                      tag ? '' : disableClassName,
                    )}
                    onClick={existingData ? () => {} : toggleTag}
                  >
                    <p>No Tags</p>
                  </div>
                  <div
                    className={classNames(
                      `choose-item${missingOriginal ? ' selected' : ''}`,
                      missingOriginal ? '' : disableClassName,
                    )}
                    onClick={existingData ? () => {} : toggleMissingOriginal}
                  >
                    <p>Missing Original Packaging</p>
                  </div>
                  <div
                    className={classNames(
                      `choose-item${defectFromManufacture ? ' selected' : ''}`,
                      defectFromManufacture ? '' : disableClassName,
                    )}
                    onClick={
                      existingData ? () => {} : toggleDefectFromManufacture
                    }
                  >
                    <p>Defect from Manufacture</p>
                  </div>
                </>
              ) : selectedCategory === 'lifestyles' ? (
                <>
                  <div
                    className={classNames(
                      `choose-item${tag ? ' selected' : ''}`,
                      tag ? '' : disableClassName,
                    )}
                    onClick={existingData ? () => {} : toggleTag}
                  >
                    <p>No Tags</p>
                  </div>
                  <div
                    className={classNames(
                      `choose-item${missingAccessories ? ' selected' : ''}`,
                      missingAccessories ? '' : disableClassName,
                    )}
                    onClick={existingData ? () => {} : toggleMissingAccessories}
                  >
                    <p>Missing Accessories</p>
                  </div>
                  <div
                    className={classNames(
                      `choose-item${defectFromManufacture ? ' selected' : ''}`,
                      defectFromManufacture ? '' : disableClassName,
                    )}
                    onClick={
                      existingData ? () => {} : toggleDefectFromManufacture
                    }
                  >
                    <p>Defect from Manufacture</p>
                  </div>
                  <div
                    className={classNames(
                      `choose-item${unassembled ? ' selected' : ''}`,
                      unassembled ? '' : disableClassName,
                    )}
                    onClick={existingData ? () => {} : toggleUnassembled}
                  >
                    <p>Unassembled</p>
                  </div>
                  <div
                    className={classNames(
                      `choose-item${scratches ? ' selected' : ''}`,
                      scratches ? '' : disableClassName,
                    )}
                    onClick={existingData ? () => {} : toggleScratches}
                  >
                    <p>Scratches</p>
                  </div>
                  <div
                    className={classNames(
                      `choose-item${repainted ? ' selected' : ''}`,
                      repainted ? '' : disableClassName,
                    )}
                    onClick={existingData ? () => {} : toggleRepainted}
                  >
                    <p>Repainted</p>
                  </div>
                  <div
                    className={classNames(
                      `choose-item${reconditioned ? ' selected' : ''}`,
                      reconditioned ? '' : disableClassName,
                    )}
                    onClick={existingData ? () => {} : toggleReconditioned}
                  >
                    <p>Reconditioned</p>
                  </div>
                  <div
                    className={classNames(
                      `choose-item${warranty ? ' selected' : ''}`,
                      warranty ? '' : disableClassName,
                    )}
                    onClick={existingData ? () => {} : toggleWarranty}
                  >
                    <p>No Warranty</p>
                  </div>
                  <div
                    className={classNames(
                      `choose-item${displayItem ? ' selected' : ''}`,
                      displayItem ? '' : disableClassName,
                    )}
                    onClick={existingData ? () => {} : toggleDisplayItem}
                  >
                    <p>Display Item</p>
                  </div>
                  <div
                    className={classNames(
                      `choose-item${discoloration ? ' selected' : ''}`,
                      discoloration ? '' : disableClassName,
                    )}
                    onClick={existingData ? () => {} : toggleDiscoloration}
                  >
                    <p>Discoloration</p>
                  </div>
                </>
              ) : (
                <>
                  <div
                    className={classNames(
                      `choose-item${missingAccessories ? ' selected' : ''}`,
                      missingAccessories ? '' : disableClassName,
                    )}
                    onClick={existingData ? () => {} : toggleMissingAccessories}
                  >
                    <p>Missing Accessories</p>
                  </div>
                  <div
                    className={classNames(
                      `choose-item${yellowing ? ' selected' : ''}`,
                      yellowing ? '' : disableClassName,
                    )}
                    onClick={existingData ? () => {} : toggleYellowing}
                  >
                    <p>Yellowing</p>
                  </div>
                  <div
                    className={classNames(
                      `choose-item${displayItem ? ' selected' : ''}`,
                      displayItem ? '' : disableClassName,
                    )}
                    onClick={existingData ? () => {} : toggleDisplayItem}
                  >
                    <p>Display Item</p>
                  </div>
                  <div
                    className={classNames(
                      `choose-item${defectFromManufacture ? ' selected' : ''}`,
                      defectFromManufacture ? '' : disableClassName,
                    )}
                    onClick={
                      existingData ? () => {} : toggleDefectFromManufacture
                    }
                  >
                    <p>Defect from Manufacture</p>
                  </div>
                </>
              )}
            </div>
          </div>
        )}
        {selectedCategory === 'handbags' && (
          <div className={'select-section'}>
            <p>Inclusion</p>
            <div className={'choose-container'}>
              <div
                className={classNames(
                  `choose-item${box ? ' selected' : ''}`,
                  box ? '' : disableClassName,
                )}
                onClick={existingData ? () => {} : toggleBox}
              >
                <p>Box</p>
              </div>
              <div
                className={classNames(
                  `choose-item${dustBag ? ' selected' : ''}`,
                  dustBag ? '' : disableClassName,
                )}
                onClick={existingData ? () => {} : toggleDustBag}
              >
                <p>Dust Bag</p>
              </div>
              <div
                className={classNames(
                  `choose-item${tag ? ' selected' : ''}`,
                  tag ? '' : disableClassName,
                )}
                onClick={existingData ? () => {} : toggleTag}
              >
                <p>Tag</p>
              </div>
              <div
                className={classNames(
                  `choose-item${mirror ? ' selected' : ''}`,
                  mirror ? '' : disableClassName,
                )}
                onClick={existingData ? () => {} : toggleMirror}
              >
                <p>Mirror</p>
              </div>
              <div
                className={classNames(
                  `choose-item${strap ? ' selected' : ''}`,
                  strap ? '' : disableClassName,
                )}
                onClick={existingData ? () => {} : toggleStrap}
              >
                <p>Strap</p>
              </div>
              <div
                className={classNames(
                  `choose-item${authenticationCard ? ' selected' : ''}`,
                  authenticationCard ? '' : disableClassName,
                )}
                onClick={existingData ? () => {} : toggleAuthenticationCard}
              >
                <p>Authentication Card</p>
              </div>
            </div>
          </div>
        )}
        {missingAccessories && selectedCategory === 'sneakers' && (
          <div className={'select-section'}>
            <p>Missing Accessories Details</p>
            <div className={'choose-container'}>
              <div
                className={classNames(
                  `choose-item${extraLace ? ' selected' : ''}`,
                  extraLace ? '' : disableClassName,
                )}
                onClick={existingData ? () => {} : toggleExtraLace}
              >
                <p>Extra Lace</p>
              </div>
              <div
                className={classNames(
                  `choose-item${wrappingPaper ? ' selected' : ''}`,
                  wrappingPaper ? '' : disableClassName,
                )}
                onClick={existingData ? () => {} : toggleWrappingPaper}
              >
                <p>Wrapping Paper</p>
              </div>
              <div
                className={classNames(
                  `choose-item${tag ? ' selected' : ''}`,
                  tag ? '' : disableClassName,
                )}
                onClick={existingData ? () => {} : toggleTag}
              >
                <p>Tag</p>
              </div>
            </div>
          </div>
        )}
        <div className={'input-section'}>
          <p>Note</p>
          <textarea
            placeholder={'Type in anything else that you think we should know'}
            onChange={handleChangeNote}
            disabled={!!existingData}
            className={disableClassName}
            value={note}
          />
        </div>
        <div className={'input-section'} ref={sneakerPriceRef}>
          <p>Selling Price</p>
          <div className={classNames('price-box', disableClassName)}>
            <p>IDR</p>
            <input
              placeholder={'Input Price'}
              // onKeyPress={onKeyPress}
              onChange={(e) => handleChangePrice(e)}
              value={
                sneakersPrice !== 0
                  ? convertToRupiah(sneakersPrice)
                  : sneakersPrice
              }
              defaultValue={
                sneakersPrice !== 0
                  ? convertToRupiah(sneakersPrice)
                  : sneakersPrice
              }
              onBlur={onBlur}
              onFocus={_validatePicture}
              disabled={!!existingData}
            />
            <IconContext.Provider value={{ color: '#fff', size: '12.5px' }}>
              <div
                className={classNames(
                  'plus-container',
                  Styles['disabled-icon'],
                )}
                onClick={() => {
                  if (existingData) {
                    return;
                  }

                  fixedPrice('increment');
                }}
              >
                <AiOutlinePlus />
              </div>
            </IconContext.Provider>
            <IconContext.Provider value={{ color: '#fff', size: '12.5px' }}>
              <div
                className={classNames(
                  'minus-container',
                  Styles['disabled-icon'],
                )}
                onClick={() => {
                  if (existingData) {
                    return;
                  }

                  fixedPrice('decrement');
                }}
              >
                <AiOutlineMinus />
              </div>
            </IconContext.Provider>
          </div>
          {hasError('sneakerPrice') ? (
            sneakersPrice >= priceCompetitorValue.max &&
            priceCompetitorValue.max !== 0 ? (
              selectedProductCondition !== 'BEKAS' && (
                <>
                  <p className={'error-text'}>Your price is not the lowest.</p>
                  <p className={'normal-text'}>
                    You will have to wait until the lowest price is sold.
                  </p>
                </>
              )
            ) : sneakersPrice < 50000 || sneakersPrice === 0 ? (
              <p className={'error-text'}>
                Your price is below the minimum requirement.
              </p>
            ) : (
              <p className={'error-text'}>
                {_.isArray(errors?.sneakerPrice)
                  ? errors?.sneakerPrice[0]
                  : errors?.sneakerPrice}
              </p>
            )
          ) : (
            selectedProductCondition !== 'BEKAS' && (
              <p className={'success-text'}>You have the lowest price.</p>
            )
          )}
          <div className={'commission-container'}>
            <p className={'normal-text'}>
              You will earn IDR{' '}
              {!priceCompetitor.data.seller_price ||
              isNaN(priceCompetitor.data.seller_price)
                ? '0'
                : convertToRupiah(priceCompetitor.data.seller_price)}{' '}
              (Commission {priceCompetitor.data.seller_commission}%)
            </p>
            <div className={'commission-info'} onClick={onToggle}>
              <KickImage src={QUESTION_ICON} />
            </div>
          </div>
        </div>
        <div className={'submit-section'}>
          <div
            className={`submit-button${!isFullFiled() ? ' disabled' : ''}`}
            onClick={existingData ? onSubmitOnlyImages : onSubmit}
          >
            <p>Submit</p>
          </div>
        </div>
      </div>
      <ModalUploadImageSell isOpen={submitSellRequest || isUploadPhoto} />
      <ModalCommissionInfo
        isOpen={isOpen}
        onToggle={onToggle}
        price={sneakersPrice}
        revenue={priceCompetitor.data.seller_price}
        commission={sneakersPrice - priceCompetitor.data.seller_price}
        commissionPercentage={priceCompetitor.data.seller_commission}
        currency={dataAuth.userCurrency.currency}
        ratio={dataAuth.userCurrency.ratio}
      />
    </div>
  );
}

const mapStateToProps = (state: stateToProps) => {
  return {
    priceCompetitor: state.dataSelling.priceCompetitor,
    dataProduct: state.dataProduct,
    sellRequest: state.dataSelling.sellRequest,
    dataSelling: state.dataSelling,
    dataAuth: state.dataAuth,
    seller_points: state.dataAuth.userdata.seller_points,
    roles: state.dataAuth.userdata.roles,
    countdown_modal: state.dataMenu.countdown_modal,
    selectedUserSell: state.dataSelling.selectedUserSell,
  };
};

const mapDispatchToProps = (dispatch: (arg0: any) => any) => {
  return {
    doSearchProduct: (query: SearchProductPayloadType, status: string) => {
      dispatch(sortingSearchResultAPI(query, status));
    },
    doGetPriceCompetitor: (params: PriceCompetitorType) =>
      dispatch(getPriceCompetitor(params)),
    doSaveImageUrl: (dataSaving: SaveImageType) =>
      dispatch(saveImageUrl(dataSaving)),
    doHandleSuspended: (id: number, status: { status: string }) =>
      dispatch(handleSuspended(id, status)),
    doMakeSellRequest: (dataSelling: SubmitDataSellingType) =>
      dispatch(makeSellRequest(dataSelling)),
    doMakeSellRequestHandbags: (dataSelling: any) =>
      dispatch(makeSellRequestHandbag(dataSelling)),
    doGetProductDetail: (id: string) => dispatch(doFetchProductDetails(id)),
    doGetTicketList: () => dispatch(getTicketListSetting()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SellRequest);
